import { useEffect, useState } from "react";
import "./sideBar.css";
import { Button, Offcanvas } from "react-bootstrap";
import useIsMobile from "../../../customHooks/useIsMobile";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import useLogout from "../../../customHooks/useLogout";
import logo from "../../../assests/logo_without_bg.gif";
import { useIsAdmin } from "../../../customHooks/roleChecker/useIsAdmin";
import { useIsSuperAdmin } from "../../../customHooks/roleChecker/useIsSuperAdmin";
import { useIsManager } from "../../../customHooks/roleChecker/useIsManager";
import { useIsSalesExecutive } from "../../../customHooks/roleChecker/useIsSalesExecutive";
import { useIsSeniorSalesExecutive } from "../../../customHooks/roleChecker/useIsSeniorSalesExecutive";

const Sidebar = () => {
  const isMobile = useIsMobile();
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  const isSuperAdmin = useIsSuperAdmin();
  const isSalesExecutive = useIsSalesExecutive();
  const isSeniorSalesExecutive = useIsSeniorSalesExecutive();
  const [show, setShow] = useState(false);
  const [activeIdx, setActiveIdx] = useState(0);
  const [showArrow, setShowArrow] = useState(true);
  useEffect(() => {
    setShow(!isMobile);
  }, [isMobile]);
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);
  const logout = useLogout();
  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY || document.documentElement.scrollTop;
      setShowArrow(scrolled <= 60);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      {showArrow && (
        <Button
          variant="outline-warning"
          onClick={handleShow}
          className={isMobile ? "m-3" : "m-4"}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
      )}

      <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="logo-wrapper">
              <img src={logo} alt="logo" className="logo" />
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="main-menu">
            {!isSalesExecutive && !isSeniorSalesExecutive ? (
              <NavLink onClick={handleClose} to="/dashboard">
                <li
                  className={activeIdx === 1 ? "active" : ""}
                  onClick={() => setActiveIdx(1)}
                >
                  Dashboard
                </li>
              </NavLink>
            ) : (
              <NavLink onClick={handleClose} to="/reporting">
                <li
                  className={activeIdx === 1 ? "active" : ""}
                  onClick={() => setActiveIdx(1)}
                >
                  Reporting
                </li>
              </NavLink>
            )}
            <NavLink onClick={handleClose} to="/order">
              <li
                className={activeIdx === 2 ? "active" : ""}
                onClick={() => setActiveIdx(2)}
              >
                Order
              </li>
            </NavLink>
            <NavLink onClick={handleClose} to="/inventory">
              <li
                className={activeIdx === 3 ? "active" : ""}
                onClick={() => setActiveIdx(3)}
              >
                Inventory
              </li>
            </NavLink>
            <NavLink onClick={handleClose} to="/category">
              <li
                className={activeIdx === 4 ? "active" : ""}
                onClick={() => setActiveIdx(4)}
              >
                Category
              </li>
            </NavLink>
            <NavLink onClick={handleClose} to="/customers">
              <li
                className={activeIdx === 5 ? "active" : ""}
                onClick={() => setActiveIdx(5)}
              >
                Customer
              </li>
            </NavLink>
            <li onClick={handleLogout}>Logout</li>
            {(isManager || isAdmin || isSuperAdmin) && (
              <div>
                <hr className="sidebar_admin_menu" />
                <NavLink onClick={handleClose} to="/users">
                  <li
                    className={activeIdx === 6 ? "active" : ""}
                    onClick={() => setActiveIdx(6)}
                  >
                    User
                  </li>
                </NavLink>
                <NavLink onClick={handleClose} to="/capital">
                  <li
                    className={activeIdx === 7 ? "active" : ""}
                    onClick={() => setActiveIdx(7)}
                  >
                    Capital
                  </li>
                </NavLink>
                <NavLink onClick={handleClose} to="/expense">
                  <li
                    className={activeIdx === 8 ? "active" : ""}
                    onClick={() => setActiveIdx(8)}
                  >
                    Spending
                  </li>
                </NavLink>
                <NavLink onClick={handleClose} to="/spending-category">
                  <li
                    className={activeIdx === 9 ? "active" : ""}
                    onClick={() => setActiveIdx(9)}
                  >
                    Spending-Category
                  </li>
                </NavLink>
              </div>
            )}
            {/* <li
              className={activeIdx === 7 ? 'active' : ''}
              onClick={() => setActiveIdx(7)}
            >
              Profile
            </li> */}
            {/* <li
              className={activeIdx === 8 ? 'active' : ''}
              onClick={() => setActiveIdx(8)}
            >
              Settings
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Sidebar;
